const lastBackgroundLayersCache = new Map();

/**
 * Checks if background DOM needs updating by comparing current vs cached background layers.
 * Uses reference equality since grid layout data is immutable.
 */
export function shouldUpdateBackgroundDom(gridNode, breakpointMediaQueries) {
  const nodeId = gridNode.getId();
  const breakpointStyles = gridNode.getValue().styles.breakpointStyles;
  for (const {
    breakpointName
  } of breakpointMediaQueries) {
    var _lastBackgroundLayers;
    if (!breakpointStyles[breakpointName]) {
      return false;
    }
    const currentBackgroundLayers = breakpointStyles[breakpointName].backgroundLayers;
    const cachedBackgroundLayers = (_lastBackgroundLayers = lastBackgroundLayersCache.get(nodeId)) === null || _lastBackgroundLayers === void 0 ? void 0 : _lastBackgroundLayers.get(breakpointName);
    if (currentBackgroundLayers !== cachedBackgroundLayers) {
      const cachedBreakpointLayerForNode = lastBackgroundLayersCache.get(nodeId);
      if (cachedBreakpointLayerForNode) {
        cachedBreakpointLayerForNode.set(breakpointName, currentBackgroundLayers);
      } else {
        lastBackgroundLayersCache.set(nodeId, new Map([[breakpointName, currentBackgroundLayers]]));
      }
      return true;
    }
  }
  return false;
}